function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#DC6B2F",
  fillRule: "nonzero",
  d: "M17.25 5.3l1.41 1.41 1.79-1.8-1.41-1.41zM11 3.95h2V1h-2zM23 10.95h-3v2h3zM1 10.95v2h3v-2z"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DC6B2F",
  d: "M9 17.197a6 6 0 1 1 6 0V22H9v-4.803z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DC6B2F",
  fillRule: "nonzero",
  d: "M3.56 4.89l1.79 1.8 1.41-1.41-1.8-1.79z"
});
const SvgProfessionalInsight = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfessionalInsight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/professional-insight.279b31a7.svg";
export { ForwardRef as ReactComponent };